import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Suppress React error overlay in production
if (process.env.NODE_ENV === 'production') {
    // Hide React error overlay
    const style = document.createElement('style');
    style.innerHTML = `
        iframe[style*="fixed"][style*="z-index: 2147483647"] {
            display: none !important;
        }
    `;
    document.head.appendChild(style);
}

// Global error handler to suppress uncaught errors from showing overlay
window.addEventListener('error', (event) => {
    // Log error to console for debugging (optional - can be removed)
    console.error('Caught error:', event.error);
    
    // Prevent the error overlay from showing
    event.preventDefault();
    event.stopPropagation();
    return false;
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
    // Log error to console for debugging (optional - can be removed)
    console.error('Unhandled promise rejection:', event.reason);
    
    // Prevent the error overlay from showing
    event.preventDefault();
    return false;
});

const root = createRoot(document.getElementById('root'));
root.render(<App />);